import { DocumentGenerationStepsStep, OptionsStep } from '@REDUCERS';
import GenerationSteps from '@CONSTANTS/GENERATION_STEPS.constant';
import { GenerationMode } from '@PAGES/manager/options/Options.page';

export const stepsRules = {
    [GenerationSteps.DOCUMENT]: {
        isRequired: true,
    },
    [GenerationSteps.TYPE]: {
        isRequired: true,
    },
    [GenerationSteps.BRAND]: {
        isRequired: true,
    },
    [GenerationSteps.LOCATION]: {
        isRequired: true,
    },
    [GenerationSteps.OPTIONS]: {
        isRequired: true,
    },
    [GenerationSteps.SELECT_CONTENT]: {
        isRequired: true,
    },
    [GenerationSteps.DOWNLOAD_DOCUMENT]: {
        isRequired: true,
    },
};

type ReturnType = { canActivate: boolean, redirect: GenerationSteps };

const DISABLED = false;

export default function validateSteps(steps: DocumentGenerationStepsStep[], current: GenerationSteps): ReturnType {
    let canActivate = true;
    let redirect = GenerationSteps.DOCUMENT;

    if (DISABLED) {
        return {
            canActivate: true,
            redirect: GenerationSteps.DOCUMENT,
        };
    }

    const currentIndex = steps.findIndex((s) => s.id === current);

    if (currentIndex === -1) return { canActivate, redirect };

    // Get the options step to check generation mode
    const optionsStep = steps.find((s) => s.id === GenerationSteps.OPTIONS) as OptionsStep | undefined;
    const isPartialMode = optionsStep?.data?.id === GenerationMode.PARTIAL;

    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const rule = stepsRules[step.id];

        // Skip SELECT_CONTENT validation if we're in full document mode
        const shouldValidateStep = !(step.id === GenerationSteps.SELECT_CONTENT && !isPartialMode);

        if (shouldValidateStep && currentIndex > i && rule.isRequired && !step.isComplete) {
            canActivate = false;
            redirect = step.id;

            break;
        }
    }

    return {
        canActivate,
        redirect,
    };
}
